import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { requestPasswordReset } from '../services/authService';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');

  async function handleSubmit(event) {
    event.preventDefault();
    const normalizedEmail = email.trim();
    if (!normalizedEmail || status === 'loading') return;

    setStatus('loading');
    setMessage('');
    try {
      const data = await requestPasswordReset(normalizedEmail);
      setStatus('success');
      setMessage(
        data?.message ||
          'If an active venue-owner account exists for this email, a password reset link has been sent.',
      );
    } catch (error) {
      setStatus('error');
      setMessage(
        error.response?.data?.message ||
          'We could not start your password reset. Please try again.',
      );
    }
  }

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="w-full max-w-md space-y-8">
        <div className="text-center">
          <Link to="/login" aria-label="Back to Court Owner Portal sign in">
            <img
              src="/freac-official-logo.png"
              alt="FREAC official logo"
              className="mx-auto h-auto w-64 object-contain"
            />
          </Link>
          <p className="mt-4 text-sm text-[#64748B] tracking-widest font-medium uppercase">
            Court Owner Portal
          </p>
        </div>

        <main className="bg-white border border-[#E5E7EB] rounded-[20px] p-8 shadow-[0_6px_18px_rgba(0,0,0,.06)]">
          <h1 className="text-2xl font-bold text-[#1F2937]">Reset your password</h1>
          <p className="mt-2 text-sm leading-6 text-[#64748B]">
            Enter the email address for your venue-owner account and we’ll send a secure reset link.
          </p>

          {status === 'success' ? (
            <div className="mt-7 rounded-xl border border-emerald-200 bg-emerald-50 p-4 text-sm leading-6 text-emerald-800" role="status">
              {message}
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="mt-7 space-y-5">
              {status === 'error' && (
                <div className="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700" role="alert">
                  {message}
                </div>
              )}
              <div>
                <label htmlFor="forgot-email" className="block text-sm font-medium text-[#64748B] mb-1">
                  Email address
                </label>
                <input
                  id="forgot-email"
                  type="email"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  autoComplete="email"
                  placeholder="you@example.com"
                  required
                  className="input-field mt-1"
                />
              </div>
              <button type="submit" disabled={status === 'loading'} className="btn-primary w-full justify-center py-2.5">
                {status === 'loading' ? 'Sending reset link…' : 'Send reset link'}
              </button>
            </form>
          )}

          <p className="mt-7 text-center text-sm text-[#64748B]">
            <Link to="/login" className="font-semibold text-[#264D59] hover:underline">
              ← Back to sign in
            </Link>
          </p>
        </main>
      </div>
    </div>
  );
}
